import { Link } from 'react-router-dom';
import { FaProjectDiagram, FaSupple, FaUsers, FaUserTie } from "react-icons/fa";
import { TbBrandBooking, TbReportMoney } from "react-icons/tb";
import { IoReceipt } from "react-icons/io5";
import { GiExpense, GiStockpiles } from "react-icons/gi";
import routePaths from "../../Navigation/routePaths";
import { useEffect, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import { meCallRequest, permissionsCallRequest } from '../../screens/onBoarding/onBoardingActions';
import HelperService from '../../utility/HelperService';
import { MdDashboard, MdMenuBook, MdMoney, MdOutlineInventory, MdRealEstateAgent, MdSupport, MdSupportAgent } from "react-icons/md";

const menuItemList: any[] = [
    {
        id: 't-1',
        icon: <MdDashboard className="menu-icon" />,
        code: "DASHBOARD",
        text: 'Dashboard',
        route: routePaths.DASHBOARD.path,
        activeRoutes: [routePaths.DASHBOARD.path, routePaths.HOME.path]
    },
    {
        id: 't-2',
        icon: <FaProjectDiagram className="menu-icon" />,
        code: "PROJECTS",
        text: 'Projects',
        route: routePaths.PROJECTPAGE.path,
        activeRoutes: [routePaths.PROJECTPAGE.path, routePaths.ADD_NEW_PROJECT.path, routePaths.UPDATE_PROJECT.path, routePaths.PROJECT_UNIT_LIST.path]
    },
    {
        id: 't-3',
        icon: <TbBrandBooking className="menu-icon" />,
        text: 'Bookings',
        code: "BOOKINGS",
        route: routePaths.BOOKING.path,
        activeRoutes: [routePaths.BOOKING.path, routePaths.BOOKING_CREATE.path, routePaths.BOOKING_UPDATE.path]
    },
    // {
    //     id: "t-4",
    //     icon: <IoReceipt className="menu-icon" />,
    //     text: "Receipts",
    //     code: "RECEIPTS", // RECEIPTS
    //     route: routePaths.RECEIPT.path,
    //     activeRoutes: [
    //         routePaths.RECEIPT.path,
    //         routePaths.RECEIPT_CREATE.path,
    //         routePaths.RECEIPT_UPDATE.path,
    //     ],
    // },
    {
        id: "t-5",
        icon: <GiExpense className="menu-icon" />,
        text: "Expenses",
        code: "EXPENSES",
        route: routePaths.EXPENSE.path,
        activeRoutes: [
            routePaths.EXPENSE.path,
            routePaths.EXPENSE_CREATE.path,
            routePaths.EXPENSE_UPDATE.path,
        ],
    },
    {
        id: 't-6',
        icon: <FaUserTie className="menu-icon" />,
        text: "Users",
        code: "USERS",
        route: routePaths.USERS.path,
        activeRoutes: [routePaths.USERS.path, routePaths.ROLE.path]
    },
    {
        id: 't-7',
        icon: <FaUsers className="menu-icon" />,
        text: "Customers",
        code: "CUSTOMERS",
        route: routePaths.CUSTOMER.path,
        activeRoutes: [routePaths.CUSTOMER.path]
    },
    {
        id: 't-8',
        icon: <MdRealEstateAgent className="menu-icon" />,
        text: "Agents",
        code: "AGENTS",
        route: routePaths.AGENTS.path,
        activeRoutes: [routePaths.AGENTS.path]
    },
    {
        id: 't-9',
        icon: <TbReportMoney className="menu-icon" />,
        text: "Payment Due Report",
        code: "PAYMENT_DUE_REPORT",
        route: routePaths.DUE_REPORT.path,
        activeRoutes: [routePaths.DUE_REPORT.path]
    },
    {
        id: 't-10',
        icon: <TbReportMoney className="menu-icon" />,
        text: "Expenses Report",
        code: "EXPENSES_REPORT",
        route: routePaths.EXPENSES_REPORT.path,
        activeRoutes: [routePaths.EXPENSES_REPORT.path]
    },
    {
        id: 't-11',
        icon: <TbReportMoney className="menu-icon" />,
        text: "Summary Report",
        code: "SUMMARY_REPORT",
        route: routePaths.SUMMARY_REPORT.path,
        activeRoutes: [routePaths.SUMMARY_REPORT.path]
    },
    {
        id: 't-12',
        icon: <MdOutlineInventory className="menu-icon" />,
        text: "Inventory",
        code: "INVENTORY",
        route: routePaths.INVENTORY.path,
        activeRoutes: [routePaths.INVENTORY.path]
    },
    {
        id: 't-13',
        icon: <GiStockpiles className="menu-icon" />,
        text: "Raw Material",
        code: "STOCK",
        route: routePaths.STOCKS.path,
        activeRoutes: [routePaths.STOCKS.path]
    },
    {
        id: 't-14',
        icon: <MdSupport className="menu-icon" />,
        text: "Suppliers",
        code: "SUPPLIERS",
        route: routePaths.SUPPLIERS.path,
        activeRoutes: [routePaths.SUPPLIERS.path]
    },
    {
        id: 't-15',
        icon: <MdMoney className="menu-icon" />,
        text: "Loan",
        code: "LOAN",
        route: routePaths.LOAN.path,
        activeRoutes: [routePaths.LOAN.path]
    },
    {
        id: 't-16',
        icon: <MdMenuBook className="menu-icon" />,
        text: "Day Book",
        code: "DAY_BOOK",
        route: routePaths.DAY_BOOK.path,
        activeRoutes: [routePaths.DAY_BOOK.path]
    }
];

interface propData {
    meCall: () => void;
    permissionsCall: () => void;
}

const VerticalMenu = (props: propData) => {
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [active, setActive] = useState<string>('');
    const [menuItems, setMenuItems] = useState<any[]>([]);

    useEffect(() => {
        token && token.token && (!token.user || HelperService.isEmptyObject(token.user)) && props.meCall();
        token && token.token && token.permissions && !token.permissions.length && props.permissionsCall();
        getActiveTab();
    }, []);

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            let arr: any[] = [];
            menuItemList.forEach((menu) => {
                if (token.permissions.findIndex((item: any) => item.name === menu.code) !== -1) {
                    arr.push(menu);
                }
            });
            setMenuItems(arr);
        }
    }, [token]);

    useEffect(() => {
        getActiveTab();
    }, [window.location.pathname]);

    const getActiveTab = () => {
        setTimeout(() => {
            const currentPath = window.location.pathname;
            let arr = [...menuItems];
            setActive('');
            arr.forEach((item) => {
                item.activeRoutes.forEach((route: any) => {
                    if (currentPath === route || currentPath.includes(route)) {
                        setActive(item.id);
                    }
                });
            });
        }, 300);
    };

    return (
        <>
            <div id="vertical_menu" className="verticle-menu">
                <div className="menu-list">
                    {/* {token && token.token && token.user && token.user.role && token.user.role.role === 'ADMIN' &&
                        <Link id={'t-6'} to={routePaths.DASHBOARD.path} onClick={() => getActiveTab()} className={"menu-item " + `${active === 't-6' ? "active" : ''}`}> <MdDashboard className="menu-icon" /> <span className='nav-text font-medium font-18'>Dashboard</span></Link>} */}
                    {menuItems.map((item, index) => {
                        return (
                            <Link key={index} id={item.id} to={item.route} onClick={() => getActiveTab()} className={"menu-item " + `${active === item.id ? "active" : ''}`}> {item.icon} <span className='nav-text font-medium font-18'>{item.text}</span></Link>
                        )
                    })}
                    {/* {token && token.token && token.user && token.user.role && token.user.role.role === 'ADMIN' &&
                        <>
                            <Link id={'t-5'} to={routePaths.USERS.path} onClick={() => getActiveTab()} className={"menu-item " + `${active === 't-5' ? "active" : ''}`}> <FaUserTie className="menu-icon" /> <span className='nav-text font-medium font-18'>Users</span></Link>
                            <Link id={'t-7'} to={routePaths.CUSTOMER.path} onClick={() => getActiveTab()} className={"menu-item " + `${active === 't-7' ? "active" : ''}`}> <FaUsers className="menu-icon" /> <span className='nav-text font-medium font-18'>Customers</span></Link>
                            <Link id={'t-8'} to={routePaths.AGENTS.path} onClick={() => getActiveTab()} className={"menu-item " + `${active === 't-8' ? "active" : ''}`}> <MdRealEstateAgent className="menu-icon" /> <span className='nav-text font-medium font-18'>Agents</span></Link>
                            <Link id={'t-9'} to={routePaths.DUE_REPORT.path} onClick={() => getActiveTab()} className={"menu-item " + `${active === 't-9' ? "active" : ''}`}> <TbReportMoney className="menu-icon" /> <span className='nav-text font-medium font-18'>Due Report</span></Link>
                        </>
                    } */}
                </div>
            </div>
        </>
    )
};

const mapDispatchToProps = (dispatch: any) => ({
    meCall: () => dispatch(meCallRequest()),
    permissionsCall: () => { dispatch(permissionsCallRequest()) }
});

export default connect(null, mapDispatchToProps)(VerticalMenu);
